<template>
  <div class="counter-block" :class="{ 'readonly': readonly }">
    <button
        v-if="!readonly"
        class="counter-minus"
        type="button"
        @click="decrement"
        :disabled="modelValue <= min"
    ></button>
    <input
        :readonly="readonly"
        class="counter-count"
        type="number"
        :value="modelValue"
        :min="min"
        @input="handleInput"
        @blur="handleBlur"
    />
    <button
        v-if="!readonly"
        class="counter-plus"
        type="button"
        @click="increment"
        :disabled="max !== null && modelValue >= max"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'CounterInput',
  props: {
    modelValue: {
      type: [Number, String],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: 1
    },
    readonly: false
  },
  emits: ['update:modelValue'],
  methods: {
    increment() {
      const newValue = Number(this.modelValue) + this.step;
      if (this.max === null || newValue <= this.max) {
        this.updateValue(newValue);
      }
    },
    decrement() {
      const newValue = Number(this.modelValue) - this.step;
      if (newValue >= this.min) {
        this.updateValue(newValue);
      }
    },
    handleInput(event) {
      const value = event.target.value;
      if (value === '') {
        this.updateValue(this.min);
        return;
      }

      let numValue = Number(value);

      if (isNaN(numValue)) {
        event.target.value = this.modelValue;
        return;
      }

      this.updateValue(numValue);
    },
    handleBlur(event) {
      let value = Number(event.target.value);

      if (isNaN(value) || value < this.min) {
        value = this.min;
      }

      if (this.max !== null && value > this.max) {
        value = this.max;
      }

      this.updateValue(value);
      event.target.value = value;
    },
    updateValue(value) {
      this.$emit('update:modelValue', value);
    }
  }
}
</script>